export default __webpack_public_path__ + "static/media/IMG_4895.63bb859e.png";